
import { getTransfersReport } from '@/api';
import DateSelect from '@/components/dashBoard/selectsFields/components/DateSelect/DateSelect.vue';
import BackButton from '@/components/UI/backButton/BackButton.vue';
import Button from '@/components/UI/button/Button.vue';
import { format } from 'date-fns';
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { notificationErrorText, timeZoneDefault } from '@/utils/PortalConstants';
import { Header } from '@/models/main';
import { TransfersReportData, TransfersStocks } from '@/models/reports';
import * as Sentry from '@sentry/vue';
import { utcToZonedTime } from 'date-fns-tz';
import DatePicker from '@/components/searchPage/DatePicker.vue';

@Component({
  components: {
    DatePicker,
    BackButton,
    DateSelect,
    Button,
  },
})
export default class TransfersReport extends Vue {
  private isLoading = false;
  private dates: string[] = [];
  private selectedBarcode = '';
  private barcodes = [
    { name: 'ADL1/Despatch', value: 'A1DESPATCH' },
    { name: 'AKL1/Despatch', value: 'AKL1/Despatch' },
    { name: 'AKLHP/Despatch', value: 'NZHPD' },
    { name: 'BNE1/Despatch', value: 'B1DES' },
    { name: 'CBR1/Despatch', value: 'C1-DESPATCH' },
    { name: 'MEL1/DES-HOLD', value: 'despatch' },
    { name: 'MEL1/Despatch', value: 'MEL1-DESPATCH' },
    { name: 'NT1/Despatch', value: 'NT1D' },
    { name: 'SWH2/Despatch', value: 'SWH2D' },
    { name: 'PER-P/Despatch', value: 'Despatch' },
    { name: 'PER-R/Despatch', value: 'PERRD' },
    { name: 'RIC/Despatch', value: 'RDES' },
    { name: 'SYD1/SYD1-DESPATCH', value: 'SYD1-DESPATCH' },
    { name: 'ADL1/Incoming', value: 'A1Incoming' },
    { name: 'AKL1/Incoming', value: 'AKL1/INCOMING' },
    { name: 'AKLHP/Incoming', value: 'NZHPI' },
    { name: 'BNE1/Incoming', value: 'B1IN' },
    { name: 'CBR1/INCOMING', value: 'C1-INCOMING' },
    { name: 'MEL1/Incoming', value: 'Mel1/Incoming' },
    { name: 'MWH2/Incoming', value: 'MWH2I' },
    { name: 'NT1/Incoming', value: 'NT1I' },
    { name: 'SWH2/Incoming', value: 'swh2I' },
    { name: 'PER-P/Incoming', value: 'INCOMING' },
    { name: 'PER-R/Incoming', value: 'PERRI' },
    { name: 'RIC/Incoming', value: 'RIN' },
    { name: 'SYD1/Incoming', value: 'sydinc' },
  ];
  private headers: Header[] = [
    { text: 'Id', value: 'id', align: 'left' },
    { text: 'State', value: 'state', align: 'left' },
    { text: 'Quants IDs', value: 'quant_ids', align: 'left' },
    { text: 'Date', value: 'date', align: 'left' },
    { text: 'Create date', value: 'create_date', align: 'left' },
    { text: 'Reserved quant IDs', value: 'reserved_quant_ids', align: 'left' },
  ];
  private transfersReportData: TransfersReportData | object = {};
  private expiredTransfers: TransfersStocks | object = {};
  private moveOutTransfers: TransfersStocks | object = {};
  private totalTransfers: TransfersStocks | object = {};

  // Date lookup
  private changeDate(dates: string[]): void {
    this.dates = dates;
  }

  private async getReportData() {
    this.transfersReportData = {};
    this.isLoading = true;
    const params = {
      dates: this.dates,
      barcode: this.selectedBarcode,
    };
    await getTransfersReport(params)
      .then(res => {
        this.transfersReportData = res;
      })
      .catch(err => {
        this.$notify({
          group: 'network',
          title: 'Error getting Transfers report',
          text: notificationErrorText,
          type: 'warn',
        });
        Sentry.withScope(scope => {
          scope.setLevel('error');
          Sentry.captureException(err);
        });
      });
    this.expiredTransfers = this.transfersReportData['expired'];
    this.moveOutTransfers = this.transfersReportData['move_out'];
    this.totalTransfers = this.transfersReportData['total'];
    this.isLoading = false;
  }

  private mounted(): void {
    this.dates = [
      format(utcToZonedTime(new Date(), timeZoneDefault), 'yyyy-MM-dd'),
      format(utcToZonedTime(new Date(), timeZoneDefault), 'yyyy-MM-dd'),
    ];
  }
}
